import { useEffect, useState } from "react";
import SecurityQuestionModal from "./modals/SecurityQuestionModal";
import { AgGridReact } from "ag-grid-react";
import { getSecurityQuestions, insertSecurityQuestion } from "../services/adminPanel_service";
import editIcon from "../../../assets/images/grid_edit.gif";

const SecurityQuestionsTab = () => {

  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowData, setRowData] = useState([]);

  const fetchSecurityQuestions = async() => {
    try{
        const response = await getSecurityQuestions();
        setRowData(response.data);
    }
    catch{
        setRowData([]);
    }
  }

  useEffect(()=>{
    fetchSecurityQuestions();
  },[]);

  const handleAdd = () => {
    setMode("add");
    setSelectedRow(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedRow(row);
    setShowModal(true);
  }

  const ActionRenderer = (params) => {
  const row = params.data;
  const isEditable = true;

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <img
        src={editIcon}
        alt="Edit"
        title="Edit Security Question"
        style={{
          width: "16px",
          cursor: isEditable ? "pointer" : "not-allowed",
          filter: isEditable ? "none" : "grayscale(100%)",
          opacity: isEditable ? 1 : 0.5,
        }}
        onClick={isEditable ? () => handleEdit(row) : undefined}
      />
    </div>
  );
};

  const columnDefs = [
    {headerName : "#", field: 'sortOrder', maxWidth: 120},
    {headerName: "Challenge Phrase", field: 'challengePhrase', flex:1},
    {
    headerName: "Action",
    field: "actions",
    cellRenderer: ActionRenderer,
    filter: false,
    sortable: false,
    maxWidth: 120
  }
  ]

  return (
    <>
      <div className="row">
        <section className="col-md-12">

          <div className="row">
            <div className="col-sm-7">
              <h3>Change Security Questions</h3>
            </div>

            <div className="col-sm-5" style={{ paddingTop: "10px" }}>
              <div className="text-right" style={{ height: "30px", float: "right" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAdd}
                >
                  Add
                </button>
              </div>
            </div>
          </div>

          <div className="clearfix"></div>
          <br />
          <div className="clearfix"></div>

          {/* Grid Placeholder */}
          <div
                  className="ag-theme-alpine"
                  style={{ height: 500, width: "100%" }}
                >
                  <AgGridReact
                  theme={'legacy'}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pagination={true}
                    animateRows={true}
                  />
                </div>

        </section>

        <div className="clearfix"></div>
        <br />
        <div className="clearfix"></div>
      </div>

      {showModal && (
        <SecurityQuestionModal
          show={showModal}
          mode={mode}
          initialData={selectedRow}
          onClose={() => {
            setShowModal(false)
          }}
          dataReload ={fetchSecurityQuestions}
        />
      )}
    </>
  );
};

export default SecurityQuestionsTab;